export default __webpack_public_path__ + "static/media/Switzer-Variable.fa6516b6.ttf";